import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
  Edit,
  EditBase,
  SimpleForm,
  TextInput,
  SelectInput,
  ReferenceInput,
  Toolbar,
  SaveButton,
  BooleanInput,
  useRecordContext,
  ShowButton,
} from "react-admin";
import {
  Typography,
  CardContent,
  Card,
  Box,
  Divider,
  Grid
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import ComponentEdit from "../../components/PageComponents/ComponentEdit";
import FormField from "../../components/Common/FormField";

// The API stores the status as 'active' / 'inactive'; the switch reads and writes those values.
const StatusInput = () => {
  const { t }: { t: any } = useTranslation();
  return (
    <BooleanInput
      source="status"
      label={t('Active')}
      format={(value) => value === 'active'}
      parse={(checked) => (checked ? 'active' : 'inactive')}
    />
  );
};

const Content = () => {
  const { t }: { t: any } = useTranslation();
  const record = useRecordContext();

  return (
    <ComponentEdit title={t('Edit user')} subtitle={record?.name || t('Update the user details, role and status.')} >
      <Card>
        <Box
          p={3}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box>
            <Typography variant="h6">
              {t('User details')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('An inactive user can no longer sign in.')}
            </Typography>
          </Box>
          {record && <ShowButton record={record} resource='users' icon={<VisibilityOutlinedIcon />} />}
        </Box>
        <Divider />
        <CardContent
          sx={{
            p: 4
          }}
        >
          <Edit redirect="show" actions={false}>
            <SimpleForm toolbar={<Toolbar sx={{ m: 2 }}><SaveButton label={t('Save')} /></Toolbar>}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormField label={t('Account')}>
                    <ReferenceInput source="accountId" reference="accounts">
                      <SelectInput label={t('Account')} fullWidth />
                    </ReferenceInput>
                  </FormField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField label={t('Name')}>
                    <TextInput source="name" label={t('Name')} fullWidth />
                  </FormField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField label={t('Email')}>
                    <TextInput source="email" label={t('Email')} fullWidth />
                  </FormField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField label={t('Role')}>
                    <SelectInput source="permissionLevel" label={t('Role')} fullWidth choices={[
                      { id: 1, name: t('Reader') },
                      { id: 4, name: t('Operator') },
                      { id: 16, name: t('Account admin') },
                      { id: 32, name: t('Reseller') },
                    ]} />
                  </FormField>
                </Grid>
                <Grid item xs={12}>
                  <FormField label={t('Status')}>
                    <StatusInput />
                  </FormField>
                </Grid>
              </Grid>
            </SimpleForm>
          </Edit>
        </CardContent>
      </Card>
    </ComponentEdit>
  )
}

const UserEdit = () => (
  <EditBase>
    <Content />
  </EditBase>
);

export default UserEdit;
